export default "__VITE_ASSET__51dd9300__"